import { FC, useEffect, useRef, useState, CSSProperties } from "react"
import { Modal } from 'bootstrap'


interface Props {
    identifier: string,
    show?: boolean,
    header?: JSX.Element | null,
    onHideModal?(): void, 
    position?: 'center' | 'none'
    aditionalClasses?: string
    dialogStyle?: CSSProperties
}


const CustomModal: FC<Props> = ({ identifier, show, header, onHideModal, children, position, aditionalClasses, dialogStyle }) => {

    const modalRef = useRef<HTMLDivElement>(null);
    const [modalObject, setModalObject] = useState<Modal | null>(null);


    useEffect(() => {
        if (modalObject === null) {
            initModal();
        }
        toggleModal();
    }, [show])


    /**
     * Instance modal
     */
    const initModal = () => {
        setTimeout(() => {
            let modalElement = modalRef.current as HTMLElement;
            let modal = new Modal(modalElement);
            modalElement.addEventListener('hidden.bs.modal', event => {
                onHideModalStatus()
            })
            setModalObject(modal);
        }, 100);
    }


    /**
     * Show or hide instanced modal depending of show prop.
     */
    const toggleModal = () => {
        let modalElement = modalRef.current as HTMLElement;

        if (show) {
            if(!modalElement.classList.contains('show')) {
                modalObject?.show();
            }
        }

        if (!show) {
            if(modalElement.classList.contains('show')) {
                modalObject?.hide();
            }
        }
    }


    const onHideModalStatus = () => {
        onHideModal && onHideModal();
    }


    return (
        <div ref={modalRef} className={`modal fade`} id={identifier} aria-hidden='true'>
            <div className={`modal-dialog ${position === 'center' ? 'modal-dialog-centered' : ''} modal-dialog-scrollable ${aditionalClasses ?? ''}`} style={dialogStyle}>
                <div className='modal-content'>
                    {children}
                </div>
            </div>
        </div>
    )
}


CustomModal.defaultProps = {
    show: false,
    header: null,
    position: 'none',
    onHideModal: () => { }
}

export default CustomModal;